import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { Select } from 'primeng/select';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appScrollIntoView]',
  standalone: true,
})
export class ScrollIntoViewDirective implements OnInit, OnDestroy {
  private select = inject(Select);

  private subscription!: Subscription;

  ngOnInit(): void {
    this.subscription = this.select.onShow.asObservable().subscribe(() => {
      this.select.overlayViewChild?.overlayViewChild?.nativeElement
        ?.querySelector('[data-p-highlight="true"]')
        ?.scrollIntoView();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
